module.exports = __webpack_public_path__ + "img/22.88ec43e7.svg";